import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Modal,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TextInput from "../../../components/inputs/textInput";
const ProductCart = ({
  items,
  columns,
  removeHandle,
  loadingRemove,
  comment,
  setComment,
}) => {
  const [removeConfirm, setRemoveConfirm] = useState(false);
  const navigate = useNavigate();
  return (
    <Box
      className={`grid grid-cols-3 border-solid border rounded-lg p-3  ${
        items?.btDisabled ? "unSelectedBox" : "selectedBox"
      }`}
    >
      <div className="col-span-3 flex flex-col gap-3 md:text-base text-sm font-bold ">
        <div className="flex justify-between items-center">
          <span> {items?.chCode}</span>{" "}
          <div className="flex gap-2">
            <IconButton>
              <EditIcon
                onClick={() => navigate(`/sell/products/${items.guidRecNo}`)}
                color="warning"
              />
            </IconButton>
            <IconButton>
              <DeleteIcon
                onClick={() => setRemoveConfirm(true)}
                color="error"
              />
            </IconButton>
          </div>
        </div>

        <div className="flex items-center gap-1">
          <span> {items?.chSaleSoftID}</span> ,{" "}
          <span> {items?.chTitle ? items?.chTitle : items.chName}</span>{" "}
        </div>
        <div className="flex items-center gap-1">
          {" "}
          <span> {items?.chMeasurementUnitName}</span>{" "}
          {items?.moUnitPrice ? (
            <>
              {" "}
              - <span>
                {" "}
                {items?.moUnitPrice?.toLocaleString("en-US")}{" "}
              </span>{" "}
              ریال{" "}
            </>
          ) : (
            <></>
          )}
        </div>
      </div>

      <Modal
        open={removeConfirm}
        onClose={() => {
          setRemoveConfirm(false);
          setComment("");
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { md: "90%", xs: "90%" },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            overflow: "auto",
            maxHeight: "95%",
            maxWidth: "400px",
          }}
        >
          <div className="py-4 px-3  mb-4 flex justify-between items-center border-b">
            <span className="text-2xl font-bold"> حذف کالا/خدمت </span>
            <div></div>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-xl">
              {" "}
              آیا از حذف {items.chTitle} اطمینان دارید ؟‌
            </span>
            <TextInput
              label="توضیحات"
              rows={2}
              onChange={(e) => setComment(e)}
              value={comment}
            />
          </div>
          <div className="flex col-span-2 justify-between items-center mt-5">
            <Button
              sx={{ width: "8rem" }}
              variant="contained"
              onClick={removeHandle}
              color="error"
            >
              {loadingRemove ? (
                <>
                  <CircularProgress size={20} />
                </>
              ) : (
                <> حذف کالا/خدمت</>
              )}
            </Button>{" "}
            <Button
              onClick={() => {
                setRemoveConfirm(false);
                setComment("");
              }}
              sx={{ width: "8rem", background: "#ccc" }}
              variant="contained"
              color="inherit"
            >
              انصرف
            </Button>
          </div>
        </Box>
      </Modal>
    </Box>
  );
};

export default ProductCart;
